import React from 'react'
import { DATA_TEST_CLASS } from 'shared-constants/build/testIds'
import styled from 'styled-components'
import type { GridTemplateColumnsProps } from 'styled-system'
import Icon, { ICON_SIZE } from 'components/Icon'
import { Grid, Flex } from 'components/Layout'
import { Text } from 'components/Typography'
import { COLOR_INTENT, FONT_WEIGHT, SPACE } from 'Theme'

const DetailLinkWrapper = styled(Flex)`
  cursor: pointer;
`

export const Row = styled(Grid)`
  &:last-child {
    margin-bottom: 0;
  }
`

type SetIsDetailVisibleCallback = (data: boolean) => boolean

interface SessionPreviewWrapperProps extends GridTemplateColumnsProps {
  hasDetail?: boolean
  isDetailVisible?: boolean
  setIsDetailVisible: (callback: SetIsDetailVisibleCallback) => void
}

export const SessionPreviewWrapper: React.FC<
  React.PWC<SessionPreviewWrapperProps>
> = ({
  hasDetail,
  isDetailVisible,
  setIsDetailVisible,
  children,
  gridTemplateColumns,
}) => (
  <Row
    width="100%"
    gridTemplateColumns={gridTemplateColumns}
    gridGap={{
      MOBILE: SPACE.PX_15,
      TABLET: SPACE.PX_15,
    }}
  >
    {children}
    {hasDetail && (
      <DetailLinkWrapper
        justifyContent={{
          MOBILE: 'flex-start',
          TABLET: 'flex-end',
        }}
        alignItems="center"
        flex-wrap="wrap"
        onClick={() => {
          setIsDetailVisible((prevState) => !prevState)
        }}
        data-test-class={DATA_TEST_CLASS.SESSION_DETAIL_BTN}
      >
        <Text
          color={COLOR_INTENT.SESSION_PREVIEW_WRAPPER.TEXT}
          mr={SPACE.PX_10}
          fontWeight={FONT_WEIGHT.SEMI_BOLD}
        >
          {isDetailVisible ? `Hide details` : `Details`}
        </Text>
        {isDetailVisible ? (
          <Icon.CaretDown size={ICON_SIZE.PX_20} />
        ) : (
          <Icon.CaretRight size={ICON_SIZE.PX_20} />
        )}
      </DetailLinkWrapper>
    )}
  </Row>
)
